import styled from "styled-components";

interface IProps {
  title: string;
  subTitle?: string;
  children?: React.ReactNode;
  isRequired?: boolean;
  isCenter?: boolean;
}

const Container = styled.div`
  display: flex;
  flex: 1;
  min-height: 40px;
  position: relative;
`;

const Header = styled.div<{ isCenter?: boolean }>`
  display: flex;
  flex: 1;
  justify-content: ${props => (props.isCenter ? "center" : "start")};
  padding-left: ${props => (props.isCenter ? "" : "20px")};
  background-color: ${props => props.theme.colors.lightGrey};
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.littleLightGrey};
  gap: 10px;
  min-width: 150px;
  max-width: 150px;
`;

const Body = styled.div`
  display: flex;
  flex: 3;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  border-bottom: 1px solid ${props => props.theme.colors.littleLightGrey};
  padding: 0px 0px 0px 10px;
  gap: 5px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h4`
  font-weight: normal;
`;

const RequiredTitle = styled.span<{ isRequired?: boolean; isCenter?: boolean }>`
  display: ${props => {
    if (!props.isRequired && props.isCenter) {
      return "none";
    }
    return "flex";
  }};
  color: ${props => {
    if (props.isRequired) {
      return props.theme.colors.darkRed;
    }
    return props.theme.colors.lightGrey;
  }};
`;

function FormTextRow({
  title,
  subTitle,
  isRequired,
  isCenter,
  children
}: IProps) {
  return (
    <Container>
      <Header isCenter={isCenter}>
        <RequiredTitle isRequired={isRequired} isCenter={isCenter}>
          *
        </RequiredTitle>
        <TitleContainer>
          <Title>{title}</Title>
          {subTitle && <Title>{subTitle}</Title>}
        </TitleContainer>
      </Header>
      <Body>{children}</Body>
    </Container>
  );
}

export default FormTextRow;
